import React from 'react';
import { Thumbnail } from '@bynder/design-system';
import { IconAspectRatioOutline, IconError } from '@bynder/icons';

import { Name, Page, PageData, PageItemStyled } from './PageItem.styled';

type Props = {
    name: string;
    width: number;
    height: number;
    isThumbnailRendering?: boolean;
    isInvalid?: boolean;
};

const PageItem = ({ name, width, height, isThumbnailRendering, isInvalid }: Props) => (
    <PageItemStyled>
        {isThumbnailRendering ? (
            <Thumbnail variant="clean" icon="">
                <Thumbnail.Overlay isLoading />
            </Thumbnail>
        ) : (
            <Thumbnail variant="clean" icon={<IconAspectRatioOutline />} size="m">
                {isInvalid && <Thumbnail.Indicator type="error" icon={<IconError />} />}
            </Thumbnail>
        )}
        <PageData>
            <Name>{name}</Name>
            <Page>
                {width} &times; {height} px
            </Page>
        </PageData>
    </PageItemStyled>
);

export default PageItem;
